export interface PageAttributeProps {
    setPathOption?: (path: string) => void;
    setButtonDetails?: (btnDetails: PathButtonAction[]) => void;
}

export interface PathButtonAction {
    type: ButtonTypeAction;
    text: string;
    isDisabled?: boolean;
    action?: () => void;
}

export enum ButtonTypeAction {
    advance = 'advance',
    revert = 'revert',
    cancel = 'cancel',
}
